// Traductions néerlandais — clé = phrase française
const dict = {
  ", à {m} chacun paie {n}": ", met {m} betaalt ieder {n}",
  "Accueil": "Home",
  "Activer le mode prof ? Votre profil apparaîtra dans « Nos professeurs » et vous pourrez créer des cours. Vous pourrez toujours revenir en mode élève.": "Leerkrachtmodus activeren? Je profiel verschijnt bij „Onze leerkrachten” en je kunt lessen aanmaken. Je kunt altijd terug naar de leerlingmodus.",
  "Administrateur": "Beheerder",
  "Administration": "Beheer",
  "Annuler": "Annuleren",
  "Apprends ensemble": "Leer samen",
  "Après le cours, vous recevez {n} ({total} − 10 % de commission Tatie Soso), quel que soit le nombre d'inscrits.": "Na de les ontvang je {n} ({total} − 10 % commissie voor Tatie Soso), ongeacht het aantal inschrijvingen.",
  "Après le cours, vous recevrez": "Na de les ontvang je",
  "Arts": "Kunst",
  "Attention : en version gratuite, Meet coupe à 60 min et Zoom à 40 min.": "Let op: in de gratis versie stopt Meet na 60 min en Zoom na 40 min.",
  "Aucun compte trouvé avec ce compte Google. Créez d'abord un compte.": "Geen account gevonden voor dit Google-account. Maak eerst een account aan.",
  "Aucun cours prévu pour l'instant.": "Voorlopig geen lessen gepland.",
  "Aucun cours trouvé pour l'instant.": "Voorlopig geen lessen gevonden.",
  "Aucun professeur trouvé.": "Geen leerkracht gevonden.",
  "Aucun utilisateur trouvé avec cet email.": "Geen gebruiker gevonden met dit e-mailadres.",
  "Aucun élève inscrit pour l'instant.": "Nog geen leerlingen ingeschreven.",
  "Aucune description.": "Geen beschrijving.",
  "Autre montant": "Ander bedrag",
  "Avis": "Beoordelingen",
  "Bonjour {name} !": "Hallo {name}!",
  "Bruxelles, Belgique": "Brussel, België",
  "Ce cours a déjà été payé au professeur : remboursement impossible.": "Deze les is al uitbetaald aan de leerkracht: terugbetaling niet mogelijk.",
  "Ce cours a déjà été payé.": "Deze les is al uitbetaald.",
  "Ce cours est complet.": "Deze les is volzet.",
  "Ce cours est déjà terminé.": "Deze les is al afgelopen.",
  "Ce cours est terminé.": "Deze les is afgelopen.",
  "Ce domaine n'est pas autorisé dans Firebase (Authentication → Settings → Authorized domains).": "Dit domein is niet toegestaan in Firebase (Authentication → Settings → Authorized domains).",
  "Ce que les élèves vont apprendre...": "Wat de leerlingen gaan leren...",
  "Cette heure est déjà passée.": "Dit tijdstip is al voorbij.",
  "Changer de mode": "Modus wijzigen",
  "Chaque nouvel inscrit fait baisser ta part (jusqu'à {min}) : tu es remboursé·e de la différence.": "Elke nieuwe inschrijving verlaagt jouw deel (tot {min}): je krijgt het verschil terug.",
  "Chargement des cours...": "Lessen laden...",
  "Chargement...": "Laden...",
  "Choisissez une date.": "Kies een datum.",
  "Choisissez une heure de début.": "Kies een beginuur.",
  "Cliquez pour entrer": "Klik om binnen te gaan",
  "Collez le lien de votre réunion (Meet, Zoom…).": "Plak de link van je vergadering (Meet, Zoom…).",
  "Comment ça marche ?": "Hoe werkt het?",
  "Complet": "Volzet",
  "Confirmer ({n} élève(s) remboursé(s))": "Bevestigen ({n} leerling(en) terugbetaald)",
  "Confirmer l'inscription": "Inschrijving bevestigen",
  "Connexion": "Inloggen",
  "Connexion / Inscription": "Inloggen / Registreren",
  "Connexion annulée.": "Inloggen geannuleerd.",
  "Continuer avec Google": "Doorgaan met Google",
  "Copier le lien de la salle": "Link van het lokaal kopiëren",
  "Cours introuvable.": "Les niet gevonden.",
  "Cours à venir": "Komende lessen",
  "Création...": "Aanmaken...",
  "Créer le cours": "Les aanmaken",
  "Créer mon compte avec Google": "Mijn account aanmaken met Google",
  "Créer un compte": "Account aanmaken",
  "Créer un cours": "Les aanmaken",
  "Créée automatiquement, gratuite, sans limite de durée. Rien à installer.": "Automatisch aangemaakt, gratis, zonder tijdslimiet. Niets te installeren.",
  "Date": "Datum",
  "Date de naissance": "Geboortedatum",
  "Des cours en petits groupes pour apprendre ensemble. Plus on est nombreux, moins c'est cher !": "Lessen in kleine groepjes om samen te leren. Hoe meer zielen, hoe goedkoper!",
  "Des cours en petits groupes — plus on est nombreux, moins c'est cher.": "Lessen in kleine groepjes — hoe meer zielen, hoe goedkoper.",
  "Des passionné·es de tous horizons, prêt·es à partager leur savoir avec toi.": "Gepassioneerde mensen van alle horizonten, klaar om hun kennis met jou te delen.",
  "Des passionné·es prêt·es à partager leur savoir": "Gepassioneerde mensen die hun kennis graag delen",
  "Description": "Beschrijving",
  "Description / Bio": "Beschrijving / Bio",
  "Document introuvable.": "Document niet gevonden.",
  "Droit": "Recht",
  "Durée": "Duur",
  "Déconnexion": "Uitloggen",
  "Déposer des fonds": "Geld storten",
  "Déposer {n}€ via PayPal": "€{n} storten via PayPal",
  "Email du destinataire": "E-mailadres van de ontvanger",
  "Email ou montant invalide.": "Ongeldig e-mailadres of bedrag.",
  "En continuant, vous acceptez les": "Door verder te gaan, aanvaard je de",
  "Enregistrement...": "Opslaan...",
  "Enregistrer": "Opslaan",
  "Ex. Fractions pour les nuls": "Bv. Breuken voor dummies",
  "Ex. Mathématiques": "Bv. Wiskunde",
  "Fermer": "Sluiten",
  "Fermer le menu": "Menu sluiten",
  "Grâce à Tatie Soso, j'ai rattrapé mes lacunes en maths en seulement 3 séances. Je recommande !": "Dankzij Tatie Soso heb ik mijn achterstand in wiskunde in amper 3 lessen ingehaald. Aanrader!",
  "Géographie": "Aardrijkskunde",
  "Gérez vos pièces d'or Tatie Soso": "Beheer je gouden Tatie Soso-munten",
  "Heure de début": "Beginuur",
  "Il n'est pas nécessaire d'être maître d'école pour donner des cours particuliers. Tatie Soso encourage tout un chacun à offrir de son temps et de sa personne pour un partage unique de connaissances. Les seuls maîtres mots sont bienveillance et apprentissage.": "Je hoeft geen schoolmeester te zijn om bijles te geven. Tatie Soso moedigt iedereen aan om tijd en energie te schenken voor een unieke kennisdeling. De enige sleutelwoorden: vriendelijkheid en leren.",
  "Ils nous font confiance": "Zij vertrouwen ons",
  "Impossible d'envoyer la photo. Réessayez plus tard.": "De foto kon niet worden verstuurd. Probeer later opnieuw.",
  "Impossible de charger vos cours.": "Je lessen konden niet worden geladen.",
  "Informatique": "Informatica",
  "Inscris-toi": "Schrijf je in",
  "J'ai trouvé un cours de droit en 24h. Tatie Soso c'est magique !": "Ik vond binnen 24 u een les recht. Tatie Soso is magisch!",
  "Je suis": "Ik ben",
  "Je suis professeur·e": "Ik ben leerkracht",
  "Je suis étudiant·e": "Ik ben leerling",
  "Je veux…": "Ik wil…",
  "L'image ne doit pas dépasser 5 Mo.": "De afbeelding mag niet groter zijn dan 5 MB.",
  "La création du cours a échoué. Vérifiez votre connexion et réessayez.": "Het aanmaken van de les is mislukt. Controleer je verbinding en probeer opnieuw.",
  "La date doit être aujourd'hui ou dans le futur.": "De datum moet vandaag of later zijn.",
  "La description doit faire au moins 10 caractères.": "De beschrijving moet minstens 10 tekens bevatten.",
  "La fenêtre de connexion a été bloquée par le navigateur. Autorisez les pop-ups puis réessayez.": "Het inlogvenster werd door de browser geblokkeerd. Sta pop-ups toe en probeer opnieuw.",
  "La salle ouvrira {n} min avant le début": "Het lokaal gaat open {n} min voor de start",
  "La suppression du cours a échoué.": "Het verwijderen van de les is mislukt.",
  "Langue": "Taal",
  "Langues": "Talen",
  "Le bouton pour rejoindre la visio apparaîtra dans « Mes cours » 15 minutes avant le début.": "De knop om aan de videoles deel te nemen verschijnt bij „Mijn lessen” 15 minuten voor de start.",
  "Le concept de partager le coût entre élèves est vraiment innovant. Bravo !": "Het idee om de kosten tussen leerlingen te verdelen is echt vernieuwend. Bravo!",
  "Le fichier doit être une image.": "Het bestand moet een afbeelding zijn.",
  "Le lien de session sera communiqué par le professeur.": "De link naar de les wordt door de leerkracht bezorgd.",
  "Le lien doit commencer par https:// et ne pas contenir d'espace.": "De link moet beginnen met https:// en mag geen spaties bevatten.",
  "Le montant doit être compris entre 1 et 1000 €.": "Het bedrag moet tussen 1 en 1000 € liggen.",
  "Le nom du cours doit faire au moins 4 caractères.": "De naam van de les moet minstens 4 tekens bevatten.",
  "Le nombre d'élèves doit être un entier ≥ 1.": "Het aantal leerlingen moet een geheel getal ≥ 1 zijn.",
  "Le paiement sera disponible à la fin du cours.": "De betaling is beschikbaar na afloop van de les.",
  "Le prix doit être d'au moins 1 pièce.": "De prijs moet minstens 1 munt zijn.",
  "Le prix est partagé entre les inscrits : si quelqu'un te rejoint, ta part passe à {next} (jusqu'à {min} si le cours est complet) et tu es remboursé·e automatiquement.": "De prijs wordt verdeeld over de ingeschrevenen: als iemand zich bij je aansluit, daalt jouw deel naar {next} (tot {min} als de les volzet is) en krijg je het verschil automatisch terug.",
  "Le sujet doit faire au moins 3 caractères.": "Het onderwerp moet minstens 3 tekens bevatten.",
  "Les avis des élèves apparaîtront ici prochainement.": "De beoordelingen van leerlingen verschijnen hier binnenkort.",
  "Les cours que j'ai rejoints": "De lessen waarvoor ik ingeschreven ben",
  "Les cours que je donne": "De lessen die ik geef",
  "Les matières": "De vakken",
  "Lien copié !": "Link gekopieerd!",
  "Lien du professeur": "Link van de leerkracht",
  "Mathématiques": "Wiskunde",
  "Mes cours": "Mijn lessen",
  "Mes cours (prof)": "Mijn lessen (leerkracht)",
  "Mode prof": "Leerkrachtmodus",
  "Mode élève": "Leerlingmodus",
  "Modifier le profil": "Profiel bewerken",
  "Modifier mon profil": "Mijn profiel bewerken",
  "Mon Portefeuille": "Mijn portemonnee",
  "Mon compte": "Mijn account",
  "Mon portefeuille": "Mijn portemonnee",
  "Mon propre lien (Google Meet, Zoom…)": "Mijn eigen link (Google Meet, Zoom…)",
  "Montant (pièces)": "Bedrag (munten)",
  "Montant (€)": "Bedrag (€)",
  "Montant invalide (entre 1 et 1000 €).": "Ongeldig bedrag (tussen 1 en 1000 €).",
  "Musique": "Muziek",
  "Navigation": "Navigatie",
  "Navigation principale": "Hoofdnavigatie",
  "Nom": "Achternaam",
  "Nom du cours": "Naam van de les",
  "Nos Professeurs": "Onze leerkrachten",
  "Nos professeurs": "Onze leerkrachten",
  "Nouveau cours": "Nieuwe les",
  "Oui, devenir prof": "Ja, leerkracht worden",
  "Ouvrir le menu": "Menu openen",
  "Où nous trouver": "Waar vind je ons",
  "Où tu veux,": "Waar je wil,",
  "Parce que l'éducation ne se limite pas à l'amélioration des résultats scolaires, Tatie Soso a pour vocation d'éveiller la curiosité des jeunes esprits. Trouve un cours adapté à tes besoins, rejoins une classe et apprends à ton rythme.": "Omdat onderwijs meer is dan betere schoolresultaten, wil Tatie Soso de nieuwsgierigheid van jonge geesten aanwakkeren. Vind een les op maat, sluit je aan bij een klas en leer op je eigen tempo.",
  "Parcours les cours disponibles ou contacte un professeur pour en créer un sur mesure.": "Blader door de beschikbare lessen of contacteer een leerkracht voor een les op maat.",
  "Participe au cours en ligne ou en présentiel, interagis avec ton professeur et tes camarades.": "Volg de les online of ter plaatse, en praat mee met je leerkracht en je klasgenoten.",
  "Passer l'intro": "Intro overslaan",
  "Passionné·e par le partage des connaissances, ce professeur est là pour t'aider à progresser.": "Deze leerkracht deelt graag kennis en helpt je graag vooruit.",
  "Payé : {n}": "Uitbetaald: {n}",
  "Places": "Plaatsen",
  "Portefeuille": "Portemonnee",
  "Prix du cours": "Prijs van de les",
  "Prix du cours (pièces)": "Prijs van de les (munten)",
  "Prix partagé entre les inscrits : un élève seul paie {n}": "Prijs gedeeld door de ingeschrevenen: één leerling alleen betaalt {n}",
  "Prix {n}": "Prijs {n}",
  "Prix {price} · tu payes {mine}": "Prijs {price} · jij betaalt {mine}",
  "Prof": "Leerkracht",
  "Professeur": "Leerkracht",
  "Professeur Tatie Soso": "Leerkracht bij Tatie Soso",
  "Professeur introuvable.": "Leerkracht niet gevonden.",
  "Professeur passionné·e par le partage des connaissances.": "Leerkracht met een passie voor kennis delen.",
  "Professeurs": "Leerkrachten",
  "Profil mis à jour": "Profiel bijgewerkt",
  "Profil utilisateur introuvable.": "Gebruikersprofiel niet gevonden.",
  "Prénom": "Voornaam",
  "Que la magie opère...": "Laat de magie werken...",
  "Quelques mots sur toi...": "Een paar woorden over jezelf...",
  "Recevoir mes pièces": "Mijn munten ontvangen",
  "Recharger mon portefeuille": "Portemonnee opladen",
  "Rechercher un cours": "Een les zoeken",
  "Rechercher un cours ou un professeur": "Een les of leerkracht zoeken",
  "Rechercher un cours, un prof…": "Zoek een les, een leerkracht…",
  "Rechercher un cours...": "Een les zoeken...",
  "Rechercher un professeur...": "Een leerkracht zoeken...",
  "Rejoindre": "Deelnemen",
  "Rejoindre l'équipe →": "Word lid van het team →",
  "Rejoindre la magie ✨": "Doe mee met de magie ✨",
  "Rejoindre le cours": "Deelnemen aan de les",
  "Rejoins la classe. Le prix est partagé entre tous les élèves inscrits — plus on est, moins c'est cher.": "Sluit je aan bij de klas. De prijs wordt verdeeld over alle ingeschreven leerlingen — hoe meer zielen, hoe goedkoper.",
  "Retour": "Terug",
  "Reviens bientôt ou contacte un professeur !": "Kom snel terug of contacteer een leerkracht!",
  "Salle Tatie Soso (Jitsi)": "Tatie Soso-lokaal (Jitsi)",
  "Salle Tatie Soso (Jitsi) — recommandé": "Tatie Soso-lokaal (Jitsi) — aanbevolen",
  "Sciences": "Wetenschappen",
  "Se connecter pour s'inscrire": "Log in om je in te schrijven",
  "Seul le professeur du cours peut être payé.": "Alleen de leerkracht van de les kan worden uitbetaald.",
  "Solde actuel": "Huidig saldo",
  "Solde insuffisant : il vous faut {need} (vous avez {have}).": "Onvoldoende saldo: je hebt {need} nodig (je hebt {have}).",
  "Solde insuffisant.": "Onvoldoende saldo.",
  "Sujet": "Onderwerp",
  "Supprimer le cours": "Les verwijderen",
  "Ta part : {n}": "Jouw deel: {n}",
  "Tatie Soso — accueil": "Tatie Soso — home",
  "Tester ma salle": "Mijn lokaal testen",
  "Ton solde : {n}": "Jouw saldo: {n}",
  "Tous droits réservés": "Alle rechten voorbehouden",
  "Transférer": "Overmaken",
  "Transférer des pièces": "Munten overmaken",
  "Trouve un cours": "Vind een les",
  "Tu payes": "Jij betaalt",
  "Tu payes maintenant": "Jij betaalt nu",
  "Une erreur est survenue. Veuillez réessayer.": "Er is een fout opgetreden. Probeer opnieuw.",
  "Une plateforme intuitive et des professeurs bienveillants. Mes enfants adorent !": "Een gebruiksvriendelijk platform en vriendelijke leerkrachten. Mijn kinderen zijn fan!",
  "Valeur Gold Coin": "Waarde Gold Coin",
  "Versement...": "Uitbetalen...",
  "Via PayPal — 1 € = 1 pièce": "Via PayPal — 1 € = 1 munt",
  "Visio": "Video",
  "Visio via {p}": "Video via {p}",
  "Visioconférence": "Videoconferentie",
  "Voir le profil →": "Profiel bekijken →",
  "Voir les cours": "Bekijk de lessen",
  "Voir les cours à venir →": "Bekijk de komende lessen →",
  "Voir les cours →": "Bekijk de lessen →",
  "Voir tous les professeurs": "Alle leerkrachten bekijken",
  "Vous devez être connecté.": "Je moet ingelogd zijn.",
  "Vous n'avez encore créé aucun cours.": "Je hebt nog geen lessen aangemaakt.",
  "Vous n'êtes inscrit·e à aucun cours pour l'instant.": "Je bent voorlopig voor geen enkele les ingeschreven.",
  "Vous ne pouvez pas vous inscrire à votre propre cours.": "Je kunt je niet inschrijven voor je eigen les.",
  "Vous ne pouvez pas vous transférer des pièces à vous-même.": "Je kunt geen munten naar jezelf overmaken.",
  "Vous pouvez suivre des cours et en donner. Changez de mode quand vous voulez.": "Je kunt lessen volgen én geven. Wissel van modus wanneer je wil.",
  "Vous êtes aussi inscrit·e à {n} cours — passez en mode élève pour les voir.": "Je bent ook ingeschreven voor {n} les(sen) — schakel over naar de leerlingmodus om ze te zien.",
  "Vous êtes déjà inscrit à ce cours.": "Je bent al ingeschreven voor deze les.",
  "Vous êtes élève. Passez en mode prof pour proposer vos propres cours.": "Je bent leerling. Schakel over naar de leerkrachtmodus om zelf lessen aan te bieden.",
  "arrivez en premier : Jitsi vous demandera de vous connecter (Google) pour ouvrir la salle": "kom als eerste: Jitsi vraagt je in te loggen (Google) om het lokaal te openen",
  "commission Tatie Soso : {n}": "commissie Tatie Soso: {n}",
  "conditions d'utilisation": "gebruiksvoorwaarden",
  "de Tatie Soso.": "van Tatie Soso.",
  "exemple@email.com": "voorbeeld@email.com",
  "https://meet.google.com/... ou https://zoom.us/j/...": "https://meet.google.com/... of https://zoom.us/j/...",
  "lien du prof": "link van de leerkracht",
  "mais ensemble": "maar samen",
  "mise à jour en temps réel": "realtime bijgewerkt",
  "profil": "profiel",
  "quand tu veux,": "wanneer je wil,",
  "rechargez votre portefeuille pour vous inscrire.": "laad je portemonnee op om je in te schrijven.",
  "voir mon compte": "mijn account bekijken",
  "{n} ajoutées à votre portefeuille !": "{n} toegevoegd aan je portemonnee!",
  "{n} inscrits": "{n} ingeschreven",
  "{n} payées par les élèves − 10 % de commission": "{n} betaald door de leerlingen − 10 % commissie",
  "{n} pièces ajoutées à votre solde.": "{n} munten toegevoegd aan je saldo.",
  "{n} pièces transférées à {email}.": "{n} munten overgemaakt naar {email}.",
  "{n} place restante": "nog {n} plaats",
  "{n} places restantes": "nog {n} plaatsen",
  "Le paiement n'a pas pu être enregistré. Contactez-nous.": "De betaling kon niet worden geregistreerd. Neem contact met ons op.",
  "Erreur PayPal. Réessayez plus tard.": "PayPal-fout. Probeer later opnieuw.",
  "Élève": "Leerling",
  "Élèves max": "Max. leerlingen",
  "Étudiant": "Leerling",
  "élèves": "leerlingen",
  // Page d'accueil
  "Bienvenue !": "Welkom!",
  "Tatie Soso, c'est pour qui ?": "Voor wie is Tatie Soso?",
  "Rejoindre l'équipe": "Word lid van het team",
  "Voir le profil": "Profiel bekijken",
  "Un peu de tout": "Van alles wat",
  "Trouve la matière qui te fait envie et découvre les prochains cours.": "Kies het vak dat je wil leren en ontdek de volgende lessen.",
  "L'équipe": "Het team",
  "Simple comme bonjour": "Kinderspel",
  "Ils en parlent": "Zij vertellen",
  // Légal / RGPD
  "Documents légaux": "Juridische documenten",
  "Mentions légales": "Wettelijke vermeldingen",
  "Conditions générales": "Algemene voorwaarden",
  "Confidentialité": "Privacy",
  "Ce document n'existe pour l'instant qu'en français. La version française fait foi.": "Dit document bestaat voorlopig alleen in het Frans. De Franse versie is rechtsgeldig.",
  "Je suis le parent ou le tuteur légal de cet enfant de moins de 13 ans, je crée ce compte pour lui et j'accepte les conditions en son nom.": "Ik ben de ouder of wettelijke voogd van dit kind jonger dan 13 jaar, ik maak dit account voor het kind aan en aanvaard de voorwaarden in zijn of haar naam.",
  "J'ai moins de 18 ans et mon parent ou tuteur légal est d'accord pour que je m'inscrive et que j'utilise Tatie Soso.": "Ik ben jonger dan 18 jaar en mijn ouder of wettelijke voogd gaat ermee akkoord dat ik me inschrijf en Tatie Soso gebruik.",
  "J'accepte les": "Ik aanvaard de",
  "conditions générales": "algemene voorwaarden",
  "et j'ai lu la": "en heb kennisgenomen van het",
  "politique de confidentialité": "privacybeleid",
  "En vous connectant, vous restez soumis·e aux": "Door in te loggen blijf je gebonden aan de",
  "et à la": "en het",
  "et je demande que le cours ait lieu à la date prévue. Je sais que je perds mon droit de rétractation de 14 jours une fois le cours donné.": "en ik vraag dat de les op de geplande datum plaatsvindt. Ik weet dat ik mijn herroepingsrecht van 14 dagen verlies zodra de les gegeven is.",
  "Accepte d'abord les conditions générales.": "Aanvaard eerst de algemene voorwaarden.",
  "Tes pièces n'expirent pas. Celles que tu n'as pas utilisées te sont remboursées sur simple demande.": "Je munten vervallen niet. Ongebruikte munten worden op eenvoudig verzoek terugbetaald.",
  "En savoir plus": "Meer weten",
  " et je commande {n} pièces pour {n} €, avec obligation de paiement. Je dispose de 14 jours pour me rétracter.": " en ik bestel {n} munten voor €{n}, met betalingsverplichting. Ik heb 14 dagen om te herroepen.",
  "Un transfert confirmé est définitif : vérifie bien l'adresse e-mail du destinataire.": "Een bevestigde overdracht is definitief: controleer het e-mailadres van de ontvanger goed.",
  "Impossible de préparer tes données. Réessaie plus tard.": "Je gegevens konden niet worden voorbereid. Probeer later opnieuw.",
  "Mes données personnelles": "Mijn persoonsgegevens",
  "Tu peux récupérer une copie de tes données ou demander la fermeture de ton compte.": "Je kunt een kopie van je gegevens downloaden of vragen om je account te sluiten.",
  "Politique de confidentialité": "Privacybeleid",
  "Télécharger mes données": "Mijn gegevens downloaden",
  "Demander la suppression de mon compte": "Verwijdering van mijn account aanvragen",
  "Nos conditions évoluent": "Onze voorwaarden veranderen",
  "Pour continuer à utiliser Tatie Soso, merci de lire et d'accepter nos conditions générales et notre politique de confidentialité.": "Om Tatie Soso te blijven gebruiken, lees en aanvaard je onze algemene voorwaarden en ons privacybeleid.",
  "Continuer": "Doorgaan",
  "Devenir prof": "Leraar worden",
  "Informations": "Informatie",
  "Contact": "Contact",
  // Connexion par e-mail et serveur
  "Adresse e-mail": "E-mailadres",
  "Adresse e-mail invalide.": "Ongeldig e-mailadres.",
  "Afficher le mot de passe": "Wachtwoord tonen",
  "Au moins 8 caractères.": "Minstens 8 tekens.",
  "C'est fait": "Gedaan",
  "Ce paiement a déjà été enregistré.": "Deze betaling is al geregistreerd.",
  "Cette adresse e-mail est déjà liée à une autre méthode de connexion (Google ou mot de passe).": "Dit e-mailadres is al gekoppeld aan een andere inlogmethode (Google of wachtwoord).",
  "Cette commande PayPal ne vous appartient pas.": "Deze PayPal-bestelling is niet van jou.",
  "Commande PayPal introuvable.": "PayPal-bestelling niet gevonden.",
  "Commande PayPal invalide.": "Ongeldige PayPal-bestelling.",
  "Confirme d'abord ton adresse e-mail (clique sur le lien reçu par e-mail).": "Bevestig eerst je e-mailadres (klik op de link in de e-mail).",
  "Confirme ton adresse e-mail : clique sur le lien envoyé à {email} (regarde aussi dans les spams).": "Bevestig je e-mailadres: klik op de link die naar {email} is gestuurd (kijk ook bij spam).",
  "Créer mon compte": "Mijn account aanmaken",
  "E-mail ou mot de passe incorrect.": "Onjuist e-mailadres of wachtwoord.",
  "E-mail renvoyé !": "E-mail opnieuw verstuurd!",
  "Il manque quelques informations pour terminer ton inscription.": "Er ontbreken nog enkele gegevens om je inschrijving af te ronden.",
  "La connexion par e-mail n'est pas encore activée sur le site.": "Inloggen met e-mail is nog niet geactiveerd op de site.",
  "Le paiement PayPal n'est pas encore configuré. Contactez-nous.": "Betalen met PayPal is nog niet ingesteld. Neem contact met ons op.",
  "Le serveur Tatie Soso ne répond pas. Réessayez dans un instant.": "De server van Tatie Soso reageert niet. Probeer het zo meteen opnieuw.",
  "Masquer le mot de passe": "Wachtwoord verbergen",
  "Mot de passe": "Wachtwoord",
  "Mot de passe oublié ?": "Wachtwoord vergeten?",
  "Mot de passe trop faible : au moins 8 caractères.": "Wachtwoord te zwak: minstens 8 tekens.",
  "Pas de connexion Internet. Vérifie ton réseau puis réessaie.": "Geen internetverbinding. Controleer je netwerk en probeer opnieuw.",
  "Pas encore confirmé. Clique sur le lien dans l'e-mail, puis réessaie.": "Nog niet bevestigd. Klik op de link in de e-mail en probeer opnieuw.",
  "Renvoyer l'e-mail": "E-mail opnieuw sturen",
  "Réservé à l'administration.": "Alleen voor beheerders.",
  "Se connecter": "Inloggen",
  "Seul le professeur du cours peut le supprimer.": "Alleen de leerkracht van de les kan ze verwijderen.",
  "Seuls les paiements en euros sont acceptés.": "Alleen betalingen in euro worden aanvaard.",
  "Si un compte existe avec cette adresse, un e-mail pour choisir un nouveau mot de passe vient d'être envoyé (pense à regarder dans les spams).": "Als er een account met dit adres bestaat, is er een e-mail verstuurd om een nieuw wachtwoord te kiezen (kijk ook bij spam).",
  "Solde invalide.": "Ongeldig saldo.",
  "Terminer mon inscription": "Mijn inschrijving afronden",
  "Trop de tentatives. Patiente quelques minutes puis réessaie.": "Te veel pogingen. Wacht enkele minuten en probeer opnieuw.",
  "Un compte existe déjà avec cette adresse e-mail. Connecte-toi (ou utilise « Mot de passe oublié »).": "Er bestaat al een account met dit e-mailadres. Log in (of gebruik „Wachtwoord vergeten”).",
  "ou": "of",
  "Écris d'abord ton adresse e-mail ci-dessus.": "Vul eerst hierboven je e-mailadres in.",
  "Bourse": "Beurs",
  "NB : la valeur réelle ne change jamais, 1 pièce = 1 €.": "NB: de echte waarde verandert nooit, 1 munt = 1 €.",
};

export default dict;
